import { createActionTypeModel } from "../../../../store/global/action-model";


export const ImportsList = createActionTypeModel('ImportsList');
export const SET_IMPORT_SENDER_RP_STATUS = 'SET_IMPORT_SENDER_RP_STATUS';
export const BasicFilter = createActionTypeModel('BasicFilter');
